








import { Vue, Component } from 'vue-property-decorator';
import ScheduleForm from './schedule-container/ScheduleForm.vue';
import SchedulePicker from './schedule-container/SchedulePicker.vue';

@Component({
    components: {
        ScheduleForm,
        SchedulePicker 
    }
})
export default class ScheduleContainer extends Vue {
    deleteReport(e: any) {
        this.$emit('deleteReport', e);
    }
}
